// extracted by mini-css-extract-plugin
export var filterIncDec = "_f9-0";
export var leftBorder = "_f9-1";
export var rightBorder = "_f9-2";
export var stringInput = "_f9-3";